var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getBoxClasses, getInputClasses, CHECKBOX_ICON_CLASSES } from 'common/vue/PrimeVueConfig/Constants/checkbox';
export default {
    root: {
        class: [
            // Layout & Interaction
            'tw-relative tw-block tw-size-5 tw-cursor-pointer tw-select-none',
        ],
    },
    box: function (_a) {
        var props = _a.props, context = _a.context;
        return (__assign({}, getBoxClasses(props, context)));
    },
    input: function (_a) {
        var props = _a.props;
        return (__assign({}, getInputClasses(props)));
    },
    icon: {
        class: CHECKBOX_ICON_CLASSES,
    },
};
